module.exports = __webpack_public_path__ + "static/media/paidy-app-qr-code-universal-stg.0d5fdf15.png";